import { usePresence } from '../../state/presence';
import { useTimelineCtx } from '../timeline/context';
import './RemotePlayheads.css';

/**
 * Collaborators' playheads, in their colours.
 *
 * Mounted alongside the local `<Playhead />` inside `.tl-content`, so it shares
 * that positioning context and inherits horizontal scroll for free — the
 * position is the same `time * pps` the local playhead uses.
 *
 * Sits below the local playhead (z-index 4 vs 5) and never takes pointer
 * events, so it cannot interfere with scrubbing the ruler.
 */
export default function RemotePlayheads() {
  const { pps } = useTimelineCtx();
  const peers = usePresence((s) => s.peers);

  return (
    <>
      {peers.map((peer) =>
        peer.playhead === null ? null : (
          <div
            key={peer.clientId}
            className="tl-remote-playhead"
            style={{ left: peer.playhead * pps, borderColor: peer.color }}
            title={peer.name}
          >
            <div className="tl-remote-flag" style={{ background: peer.color }}>
              {peer.name}
            </div>
          </div>
        ),
      )}
    </>
  );
}
